
export enum ResourceType {
  AdverseEvent = "AdverseEvent",
  AllergyIntolerance = "AllergyIntolerance",
  Appointment = "Appointment",
  Binary = "Binary",
  CarePlan = "CarePlan",
  CareTeam = "CareTeam",
  Condition = "Condition",
  Composition = "Composition",
  Coverage = "Coverage",
  Device = "Device",
  DiagnosticReport = "DiagnosticReport",
  DocumentReference = "DocumentReference",
  Encounter = "Encounter",
  ExplanationOfBenefit = "ExplanationOfBenefit",
  Goal = "Goal",
  Immunization = "Immunization",
  Location = "Location",
  Media = "Media",
  Medication = "Medication",
  MedicationDispense = "MedicationDispense",
  MedicationRequest = "MedicationRequest",
  Observation = "Observation",
  Organization = "Organization",
  Patient = "Patient",
  Practitioner = "Practitioner",
  PractitionerRole = "PractitionerRole",
  Procedure = "Procedure",
  Provenance = "Provenance",
  RelatedPerson = "RelatedPerson",
  ResearchStudy = "ResearchStudy",
  ServiceRequest = "ServiceRequest",
  Specimen = "Specimen",
}


export enum fhirVersions{
  DSTU2 = "DSTU2",
  STU3 = "STU3",
  R4 = "R4",
}
